import {PlayerBase} from "../../player/player.base";
import * as xml2js from 'xml2js'
import {ChangeDetectionStrategy, Component, Injector, ViewChild} from '@angular/core';
import {
    Observable,
    of,
    takeUntil,
    switchMap,
    forkJoin,
    animationFrames, timer
} from 'rxjs';
import {repeat, catchError, tap, map} from "rxjs/operators";
import {Expiration} from "../../interfaces/Expiration";
import {Hung} from "../../utils/hung";


@Component({
  selector: 'app-rss',
  template: `<div #component></div>`,
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RssComponent extends PlayerBase {
    myCanvas;

    ctx;
    firstIndex = 0;
    pos = 0;
    stopTimer$;

    rss;
    rtl = false;
    fontTitleStyle;
    fontDescriptionStyle;
    items;
    vertical;
    actualSize;
    size;
    space;
    index;
    speed;
    titleDiv;
    descriptionDiv;
    filter;
    offsetY = 0;
    refreshTime = 3600 * 1000;



    constructor(protected injector: Injector) {
        super(injector);
    }


    load(playerObject: any): Observable<any> {
        let self;
        return super.load(playerObject).pipe(
            switchMap(playerBase => {
                self = playerBase;
                let rss$;
                this.rss = this.data.Rss[0].$;
                this.rtl = (this.rss.rtl == '1');
                this.vertical = (this.rss.vertical == "1");
                this.speed = this.rss.speed / 60;

                if (this.rss.minRefreshTime != null && this.rss.minRefreshTime != "") {
                    this.refreshTime = Number(this.rss.minRefreshTime) * 60 * 1000;
                }

                if (this.editMode == false) {
                    this.myCanvas = document.createElement('canvas');
                    this.component.nativeElement.appendChild(this.myCanvas);

                    this.myCanvas.x = 0;
                    this.myCanvas.y = 0;
                    this.myCanvas.width = this.actualWidth;
                    this.myCanvas.height = this.actualHeight;
                    this.ctx = this.myCanvas.getContext("2d");

                    this.stopTimer$ = timer(this.refreshTime);
                }




                const fontTitle = playerObject.Data[0].Rss[0].Title[0].Font[0].$;
                this.fontTitleStyle = this.getFontStyle(fontTitle);
                const obs1$ = this.playerService.caching.requestFont(fontTitle);
                if (this.vertical) {
                    this.actualSize = this.actualHeight;
                    const fontDescription = playerObject.Data[0].Rss[0].Description[0].Font[0].$;
                    this.fontDescriptionStyle = this.getFontStyle(fontDescription);
                    this.space = 0;


                    const obs2$ = this.playerService.caching.requestFont(fontDescription);
                    rss$ = forkJoin(obs1$, obs2$);
                } else {
                    this.actualSize = this.actualWidth;
                    this.space = this.fontTitleStyle.fontSize * 2;

                    switch (this.fontTitleStyle.alignSelf) {
                        case 'start':
                            this.offsetY = this.fontTitleStyle.fontSize;
                            break;
                        case 'center':
                            this.offsetY = 0.5 * this.actualHeight;
                            break;
                        case 'end':
                            this.offsetY = this.actualHeight - this.fontTitleStyle.fontSize;
                            break
                    }
                    rss$ = obs1$;
                }
                return rss$;
            }),
            switchMap(fonts => {
                if (this.editMode) {
                    if (this.titleDiv == null) {
                        this.titleDiv = document.createElement('div');
                        this.component.nativeElement.appendChild(this.titleDiv);
                    }
                    this.titleDiv.style.fontSize = this.fontTitleStyle.fontSize + 'px';
                    this.titleDiv.style.color = this.fontTitleStyle.fill;
                    this.titleDiv.style.fontFamily = this.fontTitleStyle.fontFamily;
                    this.titleDiv.style.textDecoration = this.fontTitleStyle.textDecoration;
                    this.titleDiv.innerHTML = "RSS Title";

                    if (this.vertical) {
                        if (this.descriptionDiv == null) {
                            this.descriptionDiv = document.createElement('div');
                            this.component.nativeElement.appendChild(this.descriptionDiv);
                        }
                        this.descriptionDiv.style.fontSize = this.fontDescriptionStyle.fontSize + 'px';
                        this.descriptionDiv.style.color = this.fontDescriptionStyle.fill;
                        this.descriptionDiv.style.fontFamily = this.fontDescriptionStyle.fontFamily;
                        this.descriptionDiv.style.textDecoration = this.fontDescriptionStyle.textDecoration;
                        this.descriptionDiv.innerHTML = "rss description";
                    } else {
                        if (this.descriptionDiv != null) {
                            this.component.nativeElement.removeChild(this.descriptionDiv);
                            this.descriptionDiv = null;
                        }
                    }
                }
                return of('a')
            }),
            catchError(err => this.logError(err)),
            switchMap(a => of(self)),
            takeUntil(this.finish$)
        )
    }

    display(show) {
    }

    requestRss(): Observable<any> {
        if (this.rss.url == null) {
            this.items = this.data.Rss[0].rss[0].channel[0].item;
            return of('embeded');
        } else {
            let url = this.rss.url;
            url = url.replace(/http:/, 'https:')
            return this.playerService.caching.requestText(url, 'rss', Expiration.Minute, this.playerService.getProxyUrl()).pipe(
                switchMap(data => {
                    if (data != null && data != "") {
                        xml2js.parseString(data, (err, result) => {
                            this.items = result.rss.channel[0].item;
                            this.items = this.items.map(item => {
                                const ret:any = {};
                                ret.title = item.title?.[0];


                                if (item["description"] != null) {
                                    ret.description = item.description?.[0];
                                }
                                return ret;
                            });


                            /*
                            console.error('remove this test !!!!!');
                            for(let a=0; a<20; a++) {
                                this.items = this.items.concat(this.items);
                            }

                             */
                        })
                        return of('complete');
                    } else {
                        return of(null);
                    }
                }),
                catchError(err => {
                    return of(null);
                })
            );
        }
    }

    play(): Observable<any> {
        if (this.editMode) {
            this.display(true);
            return of('play');
        }

        return of('loop').pipe(
            switchMap(a => {
                return this.requestRss();
            }),
            switchMap(a => {
                return animationFrames().pipe(
                    tap(value => {
                        if (this.vertical) {
                            this.drawVer();
                        } else {
                            if (this.rtl) {
                                this.drawHozRtl();
                            } else {
                                this.drawHozLtr();
                            }

                        }

                    }),
                    takeUntil(this.stopTimer$)
                )
            }),
            repeat()
        )

    }

    drawHozLtr() {
        this.ctx.clearRect(0, 0, this.actualWidth, this.actualHeight);

        this.ctx.fillStyle = this.fontTitleStyle.fill;
        this.ctx.font = this.fontTitleStyle.fontSize + 'px ' + this.fontTitleStyle.fontFamily;
        this.ctx.textAlign = "left";



        let index = this.firstIndex;
        let pos = this.pos;
        let item = null;
        while(pos < this.actualWidth) {
            item = this.items[index];
            const title = item.title;
            if (item.width == null) {
                item.width = this.ctx.measureText(title).width + this.fontTitleStyle.fontSize * 2;
            }

            this.ctx.fillText(title, pos, this.offsetY);

            pos += item.width;
            index++;
            if (index == this.items.length) {
                index = 0;
            }
        }
        this.pos -= this.speed;



        const firstItem = this.items[this.firstIndex];
        if ((this.pos + firstItem.width) < 0) {
            this.firstIndex++;
            if (this.firstIndex == this.items.length) {
                this.firstIndex = 0;
            }
            this.pos += firstItem.width;
        }

    }

    drawHozRtl() {
        this.ctx.clearRect(0, 0, this.actualWidth, this.actualHeight);

        this.ctx.fillStyle = this.fontTitleStyle.fill;
        this.ctx.font = this.fontTitleStyle.fontSize + 'px ' + this.fontTitleStyle.fontFamily;
        this.ctx.textAlign = "right";

        let index = this.firstIndex;
        let pos = this.pos;
        let item = null;

        while (pos > 0) {
            item = this.items[index];
            const title = item.title;

            if (item.width == null) {
                item.width = this.ctx.measureText(title).width + this.fontTitleStyle.fontSize * 2;
            }

            this.ctx.fillText(title, pos, this.offsetY);

            pos -= item.width;
            index++;
            if (index == this.items.length) {
                index = 0;
            }
        }

        this.pos += this.speed;

        const firstItem = this.items[this.firstIndex];
        if ((this.pos - firstItem.width) > this.actualWidth) {
            this.firstIndex++;
            if (this.firstIndex == this.items.length) {
                this.firstIndex = 0;
            }
            this.pos -= firstItem.width;
        }
    }


    drawVer() {
        this.ctx.clearRect(0, 0, this.actualWidth, this.actualHeight);
        let index = this.firstIndex;
        let pos = this.pos;
        let item = null;
        while(pos < this.actualHeight) {
            item = this.items[index];
            const title = String(item.title);
            const description = String(item.description);
            this.ctx.fillStyle = this.fontTitleStyle.fill;
            this.ctx.font = this.fontTitleStyle.fontSize + 'px ' + this.fontTitleStyle.fontFamily;
            this.ctx.textAlign = this.fontTitleStyle.align;

            let height = this.wrapText(title, pos, this.fontTitleStyle.fontSize);


            if (description !=null) {
                this.ctx.fillStyle = this.fontDescriptionStyle.fill;
                this.ctx.font = this.fontDescriptionStyle.fontSize + 'px ' + this.fontDescriptionStyle.fontFamily;
                this.ctx.textAlign = this.fontDescriptionStyle.align;
                height += this.wrapText(description, pos + height, this.fontDescriptionStyle.fontSize);
            }


            height += this.fontTitleStyle.fontSize * 2;

            if (item.height == null) {
                item.height = height;
            }

            pos += item.height;



            index++;
            if (index == this.items.length) {
                index = 0;
            }
        }
        this.pos -= this.speed;



        const firstItem = this.items[this.firstIndex];
        if ((this.pos + firstItem.height) < 0) {
            this.firstIndex++;
            if (this.firstIndex == this.items.length) {
                this.firstIndex = 0;
            }
            this.pos += firstItem.height;
        }
    }

    wrapText(text, y, fontSize) {
        const words = text.split(' ');
        let line = '';
        let lines = [];
        let testWidth;

        for (let i = 0; i < words.length; i++) {
            let testLine = line + words[i] + ' ';
            testWidth = this.ctx.measureText(testLine).width;

            if (testWidth > this.actualWidth && i > 0) {
                lines.push(line.trim());
                line = words[i] + ' ';
            } else {
                line = testLine;
            }
        }

        lines.push(line.trim()); // last line

        // Determine x anchor based on textAlign
        let x;
        switch (this.ctx.textAlign) {
            case 'center':
                x = this.actualWidth / 2;
                break;
            case 'right':
            case 'end':
                x = this.actualWidth;
                break;
            case 'left':
            case 'start':
            default:
                x = 0;
                break;
        }

        for (let i = 0; i < lines.length; i++) {
            this.ctx.fillText(lines[i], x, y + i * fontSize);
        }

        return lines.length * fontSize;
    }


    destroy(): void {
        if (this.myCanvas != null) {
            this.component.nativeElement.removeChild(this.myCanvas);
            this.myCanvas = null;
            this.ctx = null;
        }

        super.destroy();
    }
}
